<template lang="pug">
  #result-list.data-table
    t-header
    t-body(v-if="!tableLoading")
    loading(v-if="tableLoading", :height="heightOfTableBody")
    //t-footer
    t-pagination(:current-page="currentPage", :last-page="lastPage", :per-page="perPage",
    @set-page="setPage", @next="setPage", @prev="setPage", @set-per-page="changePerPage")
</template>
<script>
import { SET_PAGE_NUMBER, SET_PER_PAGE, } from '../../store/modules/search/mutations-types'
import Loading from '../lei-components/Loading'
import { mapState, mapMutations, } from 'vuex'
import THeader from './THeader'
import TPagination from './TPagination'
import TFooter from './TFooter'
import TBody from './TBody'
import routerSearch from '../../mixins/router-search-mixin'
import goToSearch from '../../mixins/go-to-search'

export default {
  components: {
    TBody,
    TFooter,
    TPagination,
    THeader,
    Loading,
  },
  mixins: [ routerSearch, goToSearch, ],
  computed: {
    ...mapState('search', [
      'perPage',
      'lastPage',
      'currentPage',
      'tableLoading',
      'heightOfTableBody',
    ]),
  },
  methods: {
    changePerPage (val) {
      this.setPerPage(val)
      this.routerSearch('#results-section')
    },
    setPage (val) {
      this.scrollToResults()
      this.setPageNumber(val > this.lastPage ? this.lastPage : val)
      this.routerSearch('#results-section')
    },

    ...mapMutations(
      'search', {
        setPerPage: SET_PER_PAGE,
        setPageNumber: SET_PAGE_NUMBER,
      }
    ),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"

  .data-table
    flex-direction column
    margin 30px 0 10px

    .flag
      width: 30px;
      margin-right 10px

    .theader, .table-cells
      .country
        width 15%

      .entity-status
        width 15%

      .legal-name
        width 30%

      .lei
        width 20%

      .reg-status
        width 15%

      .selection
        width 5%

  @media screen and (max-width: $laptop-l) and (min-width: $laptop)
    .data-table
      .theader, .table-cells
        .country
          width 15%

        .entity-status
          width 15%

        .legal-name
          width 28%

        .lei
          width 17.5%

        .reg-status
          width 17.5%

        .selection
          width 7%

  @media screen and (max-width: $laptop)
    .data-table
      display flex
      margin 0 0 20px
      .theader, .table-cells
        .country
          width 15%

        .entity-status
          width 15%

        .legal-name
          width 30%

        .lei
          width 20%

        .reg-status
          width 20%
</style>



// WEBPACK FOOTER //
// src/components/data-table/DataTable.vue